<template>
    <base-container :isLoading="isLoading" ref="container">
        <base-container>
            <!-- <el-card class="box-card" style="height: 100%;overflow:hidden">
                <el-row style="height: 100%">
                    <el-col :span="24" style="height: 100%;">
                        <div v-for="(msgType, index) in temTypes" :key="msgType.value"
                            style="margin-bottom: 12px;height: 33%;">
                            <div class="project-item" style="height: 95%;overflow:hidden">
                                <div id="headerDiv" class="project-header border-bottom">
                                    <div v-text="msgType.label"></div>
                                </div>
                                <el-radio-group class="printRadio" :style="{ height: radioHeight }"
                                    v-if="getListByType(msgType.value).length > 0" v-model="msgType.radio">
                                    <el-radio border style="margin:5px 0 10px 10px"
                                        v-for="dic in getListByType(msgType.value)" :key="dic.id" :label="dic.id"
                                        @click.native.prevent="
                                            changeTmp(msgType.radio, dic.id, index)
                                            ">
                                        {{ dic.name }}</el-radio>

                                </el-radio-group>
                                <el-empty :image-size="100" :style="{ height: radioHeight }" v-else
                                    description="请先添加打印模板"></el-empty>

                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-card> -->

            <el-main ref="main" style="
          padding: 0 10px;
          height: 100%;
          display: flex;
          flex-direction: column;
        ">
                <el-tabs style="height: 100%;" tab-position="left">
                    <el-tab-pane :label="tempType.label" style="height: 100%;" v-for="(tempType, index) in temTypes"
                        :key="tempType.value">
                        <div style="height: 100%;">
                            <div class="project-item" style="height: 100%;">
                                <el-radio-group class="printRadio" :style="{ height: radioHeight }"
                                    v-if="getListByType(tempType.value).length > 0" v-model="tempType.radio">
                                    <el-radio border style="margin:5px 0 10px 10px"
                                        v-for="dic in getListByType(tempType.value)" :key="dic.id" :label="dic.id"
                                        @click.native.prevent="
                                            changeTmp(tempType.radio, dic.id, index)
                                            ">
                                        {{ dic.name }}</el-radio>
                                </el-radio-group>
                                <el-empty :image-size="100" :style="{ height: radioHeight }" v-else
                                    description="请先添加打印模板"></el-empty>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </el-main>
        </base-container>
    </base-container>
</template>
  
<script>
import { loadEnums } from "@/api/sys/dicType";
import { list, getConfig } from "@/api/jc/resource-config";
export default {
    props: {
        belongId: String,
        belongType: String,
    },
    data() {
        return {
            isLoading: false,
            temTypes: [],
            list: [],
            headerHeight: undefined,
            radioHeight: undefined,
        };
    },
    created() {
        this.isLoading = true;
        loadEnums("PrintTemplateTypeOption").then((res) => {
            this.temTypes = res.data.data.PrintTemplateTypeOption;
            if (this.temTypes.length > 0) {
                setTimeout(() => {
                    if (document.getElementById("headerDiv")) {
                        this.headerHeight = document.getElementById("headerDiv").offsetHeight
                        this.radioHeight = 'calc(100% - ' + this.headerHeight + 'px)';
                    }
                }, 0)
                this.getConfigs(this.belongId);
            } else {
                this.isLoading = false;
            }
        });
        list().then((res) => {
            this.list = res.data.data;
        });
    },
    methods: {
        getConfigs() {
            getConfig(this.belongId)
                .then((r) => {
                    let data = r.data.data;
                    if (data && data.printTemplates) {
                        this.temTypes.forEach((m) => {
                            let configs = data.printTemplates.find((d) => d.templateType == m.value);
                            if (configs) {
                                this.$set(m, "radio", configs.id);
                            } else {
                                this.$set(m, "radio", "");
                            }
                        });
                        this.isLoading = false;
                    } else {
                        this.temTypes.forEach((m) => {
                            this.$set(m, "radio", "");
                        });
                        this.isLoading = false;
                    }
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        changeTmp(changeValue, value, index) {
            if (changeValue == value) {
                this.temTypes[index].radio = "";
            } else {
                this.temTypes[index].radio = value;
            }
        },
        getListByType(value) {
            let hps = this.list.filter(
                (c) => c.templateType == value
            );
            return hps;
        },
        getData() {
            return this.temTypes;
        },
    },
};
</script>
  
<style scoped>
.artisan-group {
    height: 99%;
}

::v-deep .group-main {
    height: 100%;
}

::v-deep .el-tabs__content {
    height: 100%;
    padding: 0 0;
}


::v-deep .el-card__body {
    height: 100%;
}

::v-deep .el-card {
    overflow: auto;
}

.div1 {
    /* width: 1px; */
    height: 100%;
    background-color: rgb(217 206 206);
}

.base-container {
    overflow: hidden;
}

.project-item {
    /* height: 250px; */
    background-color: #e5e5e53d;
    position: relative;
    overflow: auto;
}

.project-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 12px;
    cursor: pointer;
}

.border-bottom {
    border-bottom: 1px solid #ebeef5;
}

.printRadio {
    overflow: auto;
}
</style>